var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-card',{attrs:{"id":"account-setting-card"}},[_c('StudentInfosForm',{attrs:{"student-infos":_vm.student,"formations":_vm.formations,"tuteurs":_vm.tuteurs,"partenaires":_vm.partenaires}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }